module.exports = __webpack_public_path__ + "img/ZG81_16.f128cb40.jpg";